const translations = {
  "en": {
    "Create Portfolio": "Create Portfolio",
    "Portfolio": "Portfolio"
  },
  "zh-tw": {
    "Create Portfolio": "建立投資組合",
    "Portfolio": "投資組合"
  }
};

export default translations;
